/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type FeedbackForm_responses$ref: FragmentReference;
declare export opaque type FeedbackForm_responses$fragmentType: FeedbackForm_responses$ref;
export type FeedbackForm_responses = {|
  +edges: $ReadOnlyArray<?{|
    +node: ?{|
      +question: {|
        +id: string
      |},
      +value: ?string,
    |}
  |}>,
  +$refType: FeedbackForm_responses$ref,
|};
export type FeedbackForm_responses$data = FeedbackForm_responses;
export type FeedbackForm_responses$key = {
  +$data?: FeedbackForm_responses$data,
  +$fragmentRefs: FeedbackForm_responses$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FeedbackForm_responses",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReviewFormResponseNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReviewFormResponseNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ReviewFormQuestionNode",
              "kind": "LinkedField",
              "name": "question",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ReviewFormResponseNodeConnection"
};
// prettier-ignore
(node/*: any*/).hash = '8f1dd4124b02f61b24b1b694fd84fc56';

module.exports = node;
